import React from "react";
import { Field } from "formik";

const Checkbox = props => {
  
  return (
    <Field name={props.name}>
      {({ field, form }) => (
        
        <div style={{display:'flex', flexDirection:'row'}} className='check-item'>
          <input
            type="checkbox"
            // {...props}
            style={{}}
            checked={ field.value.includes(props.value) || form.values[props.value] === "on"}
            // className='checkbox'
            
            
            
            
            
            
            onChange={() => {
              if (field.value.includes(props.value) && props.name !== 'inputAuthorizePhysicianOffices' && props.name !== 'inputAuthorizeA') {
                
                const nextValue = field.value.filter(
                  value => value !== props.value
                );
                form.setFieldValue(props.name, nextValue);
              } else {
                if (props.name === "inputAuthorizeA") {
                  form.setFieldValue(props.name, (form.values[props.name] === "on") ? "" : "on")
                  form.setFieldValue('facilityOrPhysician', (form.values['facilityOrPhysician'] === "on" && form.values.inputDisclosePhysicians === "") ? "" : "on")
                }
                
                else if (props.name === "inputAuthorizePhysicianOffices") {
                  form.setFieldValue(props.name, (form.values[props.name] === "on") ? "off" : "on")
                }

                if(props.name === "sensitiveInfo" && props.value === "authorizeAll" || props.value === "notAuthorizeAll"){
                  if (props.value === "authorizeAll"){
                    const nextValue = (form.values[props.value] === "on") ? "off" : "on";

                    form.setFieldValue(props.value, nextValue);
                    form.setFieldValue("excludepsy", "on");
                    form.setFieldValue("excludedrug", "on");
                    form.setFieldValue("excludeHIV", "on");
                    form.setFieldValue("excludeSTD", "on");
                    form.setFieldValue("excludegenetics", "on");
                    form.setFieldValue("notAuthorizeAll", "off");
                    
                  }
                  else if (props.value === "notAuthorizeAll"){
                    const nextValue = (form.values[props.value] === "on") ? "off" : "on";

                    form.setFieldValue(props.value, nextValue);
                    form.setFieldValue("excludepsy", "off");
                    form.setFieldValue("excludedrug", "off");
                    form.setFieldValue("excludeHIV", "off");
                    form.setFieldValue("excludeSTD", "off");
                    form.setFieldValue("excludegenetics", "off");
                    form.setFieldValue("authorizeAll", "off");
                  }
                    
                  // const nextValue = [props.value];
                  // form.setFieldValue(props.name, nextValue);
                  
                    
                }
                // else if(props.name === "sensitiveInfo" && props.value < 90){
                //     const cleanArray = field.value.filter(
                //       value => value < 90
                //     );
                //     const nextValue = cleanArray.concat(props.value);
                //   form.setFieldValue(props.value, nextValue);
                  
                // }
                else{
                  const nextValue = (form.values[props.value] === "on") ? "off" : "on";
                  form.setFieldValue(props.value, nextValue);
                  form.setFieldValue("authorizeAll", "off");
                  form.setFieldValue("notAuthorizeAll", "off");
                  
                }
                
              }
            }}
          />
          <label htmlFor={props.value} className='paragraph' style={props.style}>{props.label}</label>
        </div>
      )}
    </Field>
  );
};

export default Checkbox;
